// extracted by mini-css-extract-plugin
export default {"flowStartCard":"FlowStartCard_flowStartCard__qptx8","text":"FlowStartCard_text__3VNHM","hiddenHandler":"FlowStartCard_hiddenHandler__-cpHh"};